// extracted by mini-css-extract-plugin
export default {"dummy":"GearContainer_dummy__tUZj7","placeHolderShimmer":"GearContainer_placeHolderShimmer__cGzh+"};